import { render, staticRenderFns } from "./ItsSalesInnerSpendDepartDetail.vue?vue&type=template&id=4c02977b&scoped=true&"
import script from "./ItsSalesInnerSpendDepartDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesInnerSpendDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesInnerSpendDepartDetail.vue?vue&type=style&index=0&id=4c02977b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02977b",
  null
  
)

export default component.exports